export { CategoryTiles } from "./CategoryTiles";
export type {
	CategoryTilesProps,
	CategoryTile,
	CategoryTilesShopAll
} from "./CategoryTiles";
